import { Module } from 'vuex';
import { Nullable, RootState } from 'frontend/types';

export interface SponsorModalState {
  show_sponsor_modal: boolean;
  sponsor_modal_copy: string;
  sponsor_logo: Nullable<string>;
  sponsor_fans_name: string;
  promotion_name: string;
  sponsor_name: string;
  percent_off: Nullable<string>;
}

const sponsorModalInfo: Module<SponsorModalState, RootState> = {
  namespaced: true,
  state: {} as SponsorModalState,
  mutations: {
    setValue(state: SponsorModalState, value: SponsorModalState): void {
      Object.assign(state, value);
    },
  },
  getters: {
    sponsorLogo(state: SponsorModalState): Nullable<string> {
      return state.sponsor_logo;
    },
  },
};

export default sponsorModalInfo;
